module.exports = __webpack_public_path__ + "static/media/video-breathing-zh.0b9cd412.vtt";